import { gsap } from "gsap";
import { ScrollToPlugin, Power4 } from "gsap/all";
gsap.registerPlugin(ScrollToPlugin);

document.addEventListener('DOMContentLoaded',function() {

    const btnGoTo = document.getElementsByClassName('js-goto');
    const timeline = document.getElementById('timeline');
	const clickAction = function(e) {

	    const that = e.currentTarget;

	    let src = that.getAttribute('href');

	    if (!src) {
	        src = that.getElementsByTagName('a')[0].getAttribute('href');
        }

	    if (e.currentTarget.classList.contains('js-setCategory')) {
	        window.setCategory(e.currentTarget.dataset.category);
        }

        if (timeline) {
            const year = timeline.getElementsByClassName('js-year');

            for (let i = 0; i < year.length; i++) {
                year[i].classList.remove('is-active');
            }
        }

        e.currentTarget.classList.add('is-active');
        gsap.to(window, { duration: 1, scrollTo: { y: src, offsetY: document.getElementById('top').clientHeight }, ease: Power4.easeInOut });

	    e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
	};

    if (btnGoTo.length > 0) {
        for (let i = 0; i < btnGoTo.length; i++) {
            btnGoTo[i].addEventListener('click', clickAction);
        }
    }
}, false);
